// src/services/leasesPortfolioCache.js
//
// Slice U5b — in-memory client cache for the two portfolio lease
// intelligence reads (GET /api/critical-dates, GET /api/watch-items).
//
// Mirror of services/reportsCache.js: same TTL, same shape, same
// "full bust on every write" rule enforced via services/cacheBus.js.
// Kept as a separate store so each cache module owns its own keys
// and can be reset independently in tests (e.g. leasesPortfolioClient.test.js).
//
// Cache keys:
//   "critical-dates-v3"  -> Array<CriticalDateRow> including notice-boundary metadata and field sources
//   "watch-items"     -> Array<WatchItemRow>

const TTL_MS = 5 * 60 * 1000; // 5 minutes — matches reportsCache

/** @type {Map<string, { value: any, expiresAt: number }>} */
const store = new Map();
let generation = 0;

// A read started before invalidation must not repopulate this store afterwards.
export function getGeneration() {
  return generation;
}

export function get(key) {
  const entry = store.get(key);
  if (!entry) return undefined;
  if (Date.now() >= entry.expiresAt) {
    store.delete(key);
    return undefined;
  }
  return entry.value;
}

export function set(key, value) {
  store.set(key, { value, expiresAt: Date.now() + TTL_MS });
}

export function invalidateAll() {
  generation++;
  store.clear();
}

export function __resetForTests() {
  invalidateAll();
}

export function __sizeForTests() {
  return store.size;
}

export const KEY_CRITICAL_DATES           = "critical-dates-v3";
export const KEY_WATCH_ITEMS              = "watch-items";
export const KEY_UNSPENT_ALLOWANCES       = "unspent-allowances";      // slice M1.5a
export const KEY_UNSPENT_ALLOWANCE_ROWS   = "unspent-allowance-rows";  // near-expiry row report
export const KEY_PORTFOLIO_LEASES         = "portfolio-leases-v5";     // separate canonical and displayed footprints
export const TTL_MS_FOR_TESTS             = TTL_MS;
